import { useTranslation } from "react-i18next";
import { OrkevaLoader } from "@/components/OrkevaLoader";
import { Brain, Search, ShieldCheck, Calculator } from "lucide-react";

// Kept for backward-compatible imports; the premium loader drives its own status.
export const ENGINE_STAGES = [
  { icon: Brain, label: "Generating alternatives" },
  { icon: Search, label: "Grounding with evidence" },
  { icon: Calculator, label: "Scoring against your priorities" },
  { icon: ShieldCheck, label: "Running the Trust Layer" },
];

export function EvaluatingState() {
  const { t } = useTranslation();
  const stages = t("loader.stages", { returnObjects: true });
  return (
    <OrkevaLoader
      title={t("loader.title")}
      subtitle={t("loader.subtitle")}
      stages={Array.isArray(stages) ? stages : undefined}
      testId="evaluating-state"
    />
  );
}
